import React from 'react'

import styles from './index.module.css'

export function Animation() {
  return <div className={styles.placeholderAnimation} />
}

Animation.displayName = 'Placeholder.Animation'
